import { Button, setRoute } from '@iqueue/ui-kit'

export default function GoToHome() {
  return <Button
    flat
    title={ 'На главную' }
    onClick={ () => setRoute('/') }
  />
}
